<ion-header>
    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="cancel()">
                <ion-icon slot="icon-only" name="arrow-back"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-searchbar [(ngModel)]="queryText" placeholder="Search Plant"></ion-searchbar>
        <ion-button (click)="addDetailLines()" color="success" slot="end" shape="round">
            <ion-icon name="checkmark" slot="icon-only"></ion-icon>
        </ion-button>
    </ion-toolbar>
</ion-header>

<ion-content>
    <ion-grid>
        <ion-row class="row" *ngFor="let dtLine of groupedDetailLines | filterDetailLine: queryText">
            <ion-col size="2" align-self-center text-center
                     (click)="dtLine.isChecked = !dtLine.isChecked">
                <ion-button color="none" size="small">
                    <ion-icon slot="icon-only" [name]="dtLine.isChecked ? 'checkbox-outline' : 'square-outline'"
                              [color]="dtLine.isChecked ? 'success' : 'danger'"></ion-icon>
                </ion-button>
            </ion-col>
            <ion-col size="7" (click)="dtLine.isChecked = !dtLine.isChecked" align-self-center>
                <ion-label text-wrap>{{ dtLine.line.description }}</ion-label>
            </ion-col>
            <ion-col size="3" no-margin no-padding align-self-center>
                <ion-item lines="none" no-margin no-padding
                          [ngStyle]="dtLine.isChecked ? {'background-color': darkColor} : {'background-color': lightColor}">
                    <ion-input type="number" (ionChange)="checkQty($event, dtLine)" [(ngModel)]="dtLine.line.qty"
                               placeholder="Set Quantity" text-end no-margin no-padding>
                    </ion-input>
                </ion-item>
            </ion-col>
        </ion-row>
    </ion-grid>
</ion-content>
